module.exports = __webpack_public_path__ + "static/media/Group 9998.ddc09403.svg";